import PropTypes from 'prop-types';

import styles from 'styles/components/checkout/caap/spc/infoAlert.scss';
import marketplace from 'cfg/marketplace.json';

const { checkout: { showFreeShippingBanner } } = marketplace;

const InfoAlert = ({ shippingCharge }, { testId }) => {
  if (showFreeShippingBanner && shippingCharge === 0) {
    return (
      <div className={`${styles.freeShippingSection} ${styles.hideSmallScreen}`} data-test-id={testId('freeShipping')}>
        Your order qualifies for FREE SHIPPING!
      </div>
    );
  }

  return null;
};

InfoAlert.contextTypes = {
  testId: PropTypes.func
};

export default InfoAlert;
